import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Moon, Sun, Menu, X, Github, Sparkles } from 'lucide-react';
import { useState } from 'react';
import { useThemeStore } from '../store/theme';
import { useAuthStore } from '../store/auth';

export function Header() {
  const { theme, toggle } = useThemeStore();
  const { role, user, logout } = useAuthStore();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navItems = [
    { label: '首页', to: '/' },
    { label: '文库', to: '/library' },
  ];

  if (role === 'admin') {
    navItems.push({ label: '后台', to: '/admin' });
  }

  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b border-stone-200/80 bg-white/80 backdrop-blur-md dark:border-indigo-500/10 dark:bg-space-900/80">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/profile" className="flex items-center gap-2">
          <Sparkles className="text-indigo-500" size={22} />
          <span className="text-lg font-bold tracking-tight text-stone-900 dark:text-star">
            zhaoxi的个人博客
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {navItems.map((item) => (
            <Link key={item.to} to={item.to} className="nav-link text-sm font-medium">
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {role === 'guest' ? (
            <a
              href={`${import.meta.env.VITE_API_URL || '/api'}/auth/github?redirect=${encodeURIComponent(window.location.origin + '/oauth/callback')}`}
              className="btn-press hidden items-center gap-2 rounded-full bg-stone-900 px-4 py-2 text-sm font-medium text-white transition-transform hover:scale-105 dark:bg-nebula dark:text-white md:flex"
            >
              <Github size={16} />
              登录
            </a>
          ) : (
            <div className="hidden items-center gap-3 md:flex">
              {user?.avatar_url ? (
                <img src={user.avatar_url} alt={user.name} className="h-8 w-8 rounded-full ring-2 ring-indigo-500/30" />
              ) : null}
              <span className="text-sm text-stone-600 dark:text-star-dim">{user?.name}</span>
              <button
                onClick={logout}
                className="text-sm text-stone-500 hover:text-stone-900 dark:text-star-dim dark:hover:text-star"
              >
                退出
              </button>
            </div>
          )}

          <button
            onClick={toggle}
            className="btn-press rounded-full p-2 text-stone-600 transition-colors hover:bg-stone-100 dark:text-star-dim dark:hover:bg-space-800"
            aria-label="toggle theme"
          >
            {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
          </button>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="rounded-lg p-2 text-stone-600 hover:bg-stone-100 dark:text-star-dim dark:hover:bg-space-800 md:hidden"
          >
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="border-t border-stone-200 bg-white px-4 py-4 dark:border-indigo-500/10 dark:bg-space-900 md:hidden"
        >
          <nav className="flex flex-col gap-3">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMobileOpen(false)}
                className="text-base font-medium text-stone-700 dark:text-star"
              >
                {item.label}
              </Link>
            ))}
            {role === 'guest' && (
              <a
                href={`${import.meta.env.VITE_API_URL || '/api'}/auth/github?redirect=${encodeURIComponent(window.location.origin + '/oauth/callback')}`}
                className="mt-2 flex items-center justify-center gap-2 rounded-full bg-stone-900 py-2 text-sm font-medium text-white dark:bg-nebula"
              >
                <Github size={16} />
                GitHub 登录
              </a>
            )}
          </nav>
        </motion.div>
      )}
    </header>
  );
}
